<template>
  <div class="bg-white"  :class="isSushi && 'montserrat-700'">
    <div class="row m-4 justify-content-center">
      <div class="col-lg-9 bg-white py-4">
        <form class="p-4 d-flex flex-wrap justify-content-center" @submit.prevent="submitForm">
          <div class="container">
            <navigate-user-back />
          </div>
          <div class="container my-4">
            <h1>{{ $t('message.myAccount') }}</h1>
          </div>
          <my-detail ref="myDetail" :edit-model="detailModel" />
          <cards :dbuser="dbuser" :isSushi="isSushi" />
          <div
            v-if="success"
            class="alert alert-primary p-4 mt-4 alert-color w-100"
            role="alert"
          >{{ $t('message.profileSavedSuccessfully') }}</div>
          <div
            v-if="hasError"
            class="alert alert-danger p-4 mt-4 alert-color w-100"
            role="alert"
          >{{ hasError }}</div>
          <div class="w-50" style="margin-top:4rem">
            <button
              :disabled="loading"
              type="submit"
              class="btn btn-lg btn-block shadow btn-primary d-flex justify-content-center align-items-center"
              :style="desktopStyles.btn"
            >
              {{ $t('message.saveChanges') }}
              <span v-show="loading">
                <i class="spin ml-4" />
              </span>
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import MyDetail from "./MyDetail";
import cards from "./cards";
import { mapGetters, mapActions } from "vuex";
import { getDBUser } from "../../api/services/userService.js";
import shared from "../../sharedscripts/user/profile.js";
import NavigateUserBack from "@/components/user/partials/navigateUserBack";
export default {
  components: {
    NavigateUserBack,
    MyDetail,
    cards
  },
  data() {
    return {
      detailModel: {
        FirstName: "",
        LastName: "",
        Email: "",
        Phone:""
      },
      dbuser: {},
      hasError: "",
      success: false,
      loading: false
    };
  },
  computed: {
    ...mapGetters(["user", "hqDoc", "desktopStyles", "currentStoreDoc"]),
    isSushi() {
      return this.hqDoc && this.hqDoc.IsSushiHub;
    }
  },
  watch: {
    user() {
      let that = this;
      if (this.user) {
        getDBUser(this.user.id).onSnapshot(
          function(doc) {
            if (doc.exists) {
              that.dbuser = doc.data();
              that.initModel();
            }
          },
          function(reason) {
            that.insertErrorlog([
              reason.name,
              reason.toString(),
              that.$router.currentRoute.fullPath
            ]);
            that.redirectToErrorPage();
          }
        );
      }
    }
  },
  mounted() {
    this.setStoreLoaded();
    let that = this;
    if (this.user) {
      getDBUser(this.user.id).onSnapshot(
        function(doc) {
          if (doc.exists) {
            that.dbuser = doc.data();
            that.initModel();
          }
        },
        function(reason) {
          that.insertErrorlog([
            reason.name,
            reason.toString(),
            that.$router.currentRoute.fullPath
          ]);
          that.redirectToErrorPage();
        }
      );
    }
  },
  methods: {
    ...mapActions(["insertErrorlog", "redirectToErrorPage"]),
    ...shared.methods
  }
};
</script>
